import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react'
import ChartWrapper from './ChartWrapper'
import moment from 'moment'
import { mmHgToKPa, celsiusToFahrenheit, percentTommHg, percentToKpa, mmHgToPercent, unitStringByType, checkEmptyValue, checkIBPZero, speedStringByType, valueStringByType, isDetectingStringByType, levelStringByType, colorByPriority, getVSMFontSize, getAlarmStringByType } from '../plugins/common'
import { useRecoilState, useRecoilValue, useRecoilCallback } from 'recoil';
import { measurementStateFamily, demoModeState, isFromSearchState, wardState, selectBedInfoState, unitState, alarmsState, alarmStateFamily, silenceStateFamily, wardSuspendState, wardSilenceState,globalParameterColorState, globalConnectedDeviceState, deviceModelInfo, v20DatasState} from '../plugins/recoil';
import axios from '../plugins/axios'
import { useTranslation } from 'react-i18next';
import { useBedData } from '../context/BedDataContext';
import PatientNumeric from './PatientNumeric'
import { getStyles32 } from './PatientNumeric/getNumericStyles'

import {ReactComponent as IconAlarmOff} from '../assets/icons/ic-alarm-suspend.svg'
import {ReactComponent as IconAlarmOn} from '../assets/icons/ic-alarm-on.svg'
import {ReactComponent as IconAlarmReview} from '../assets/icons/ic-alarm-review.svg'
import {ReactComponent as IconAlarmOnBlack} from '../assets/icons/ic-alarm-on-black.svg'
import {ReactComponent as IconAlarmOffBlack} from '../assets/icons/ic-alarm-off-black.svg'
import {ReactComponent as IconNoConnection} from '../assets/icons/ic-no-connection.svg'
import {ReactComponent as IconNoConnectionBlack} from '../assets/icons/ic-no-connection-black.svg'
import {ReactComponent as IconAlarmSilence} from '../assets/icons/ic-alarm-silence.svg'
import {ReactComponent as IconSetting} from '../assets/icons/ic-setting.svg'
import {ReactComponent as IconTrend} from '../assets/icons/ic-trend.svg'
import {ReactComponent as IconMeasurements} from '../assets/icons/ic-measurements.svg'
import {ReactComponent as IconAcknowledge} from '../assets/icons/ic-acknowledge.svg'

import AlarmDropdown from './AlarmDropdown'
import useAlarm from './useAlarm';

import './Patient.scss'
const Patient = ({ bedInfo, bedData, viewType, initialHeight, patientCnt, handleTrend, handleAlarmReview, handleBedSetting, handleMeasurements, wardStatusChangeFlag,handleStandByConfirm
}) => {
    const { t } = useTranslation()
    const [arr, setArr] = useState([0])
    const [dataCountArr, setDataCountArr] = useState([0])
    const [isMouseOver, setIsMouseOver] = useState(false)
    const [isStandbyMode, setIsStandByMode] = useState(false)
    const prevStandbyModeRef = useRef(isStandbyMode)
    const isFirstStandbyRenderRef = useRef(true)
    const [demoMode, ] = useRecoilState(demoModeState)
    const prevDemoModeRef = useRef(demoMode)
    const [curWard, ] = useRecoilState(wardState)
    const [height, setHeight] = useState(0)
    const [alarms,] = useRecoilState(alarmsState)
    const [isFromSearch, setIsFromSearch] = useRecoilState(isFromSearchState)
    const [measurementSettings, setMeasurementSettings] = useRecoilState(measurementStateFamily(bedInfo.serial))
    const { isAlarmEnabled, alarmActive, handleSilence, handleUnsilence, alarmPriorities ,remainingSeconds, isSilenced, unSilenceAll, handleAcknowledge, acknowledgeRemainingSeconds, isAcknowledged, hasUnacknowledgedAlarms, unacknowledgedAlarmsCount, highestUnacknowledgedPriority, getAlarmAcknowledgeStatus, getAcknowledgedTime, clearAlarmState } = useAlarm(bedData, bedInfo, true);
    const [vsData, setVsData] = useState({})
    // const [vsDetecting, setVsDetecting] = useState({})
    const [settingStatus, setSettingStatus] = useState({})
    const [outOfRange, setOutOfRange] = useState([])
    const [alarmLimitData, setAlarmLimitData] = useState({})
    const [isDisconnected, setIsDisconnected] = useState(true)
    const [selectBedInfo, setSelectBedInfo] = useRecoilState(selectBedInfoState)
    const isDisconnectedTimerRef = useRef(null)
    const highestPriority = alarms[bedInfo.serial]?.length > 0 ? alarms[bedInfo.serial][0].type : null;
    const wardSuspend = useRecoilValue(wardSuspendState);
    const wardSilence = useRecoilValue(wardSilenceState);
    const isWardSuspended = wardSuspend === '1';
    const isWardSilenced = wardSuspend === "2" && wardSilence.isSilenced;// 병동 Silence 여부
    const highIntervalRef = useRef(null)
    const mediumIntervalRef = useRef(null)
    const [highTypes, setHighTypes] = useState([])
    const [mediumTypes, setMediumTypes] = useState([])
    const [lowTypes, setLowTypes] = useState([])
    const [highHighlight, setHighHighlight] = useState(false)
    const [mediumHighlight, setMediumHighlight] = useState(false)
    const highHighlightRef = useRef(highHighlight)
    const mediumHighlightRef = useRef(mediumHighlight)
    const [lowHighlight, setLowHighlight] = useState(false)
    const [units, setUnits] = useRecoilState(unitState)
    const priorityOrder = { 'High': 1, 1: 'High', 'Medium': 2, 2:'Medium', 'Low': 3, 3: 'Low', 'Normal': 4, 4: 'Normal' };
    const [parameterColors, ] = useRecoilState(globalParameterColorState);
    const [isDetecting, setIsDetecting] = useState({ ...isDetectingStringByType })
    const [deviceModelMenus, ] = useRecoilState(deviceModelInfo);
    const [, setV20DatasState] = useRecoilState(v20DatasState);
    const { updateBedData, clearDataQueue } = useBedData()
    
    const [,setGlobalConnectedDevice] = useRecoilState(globalConnectedDeviceState);
    

    const getAlarmString = (vsType, onlyValue) => {
        const vitalSignType = vsType === 'awRR' ? 'RR' : vsType
        const highAlarmString = getAlarmStringByType(vitalSignType, 'high')
        const lowAlarmString = getAlarmStringByType(vitalSignType, 'low')
        
        if (onlyValue) {
            if (highAlarmString) return checkEmptyValue(settingStatus[highAlarmString])
            else return '---'
        }

        if (highAlarmString || lowAlarmString) {
            if (['NIBPSYS', 'NIBPDIA', 'NIBPMEAN', 'IBP1SYS', 'IBP1DIA', 'IBP1MEAN', 'IBP2SYS', 'IBP2DIA', 'IBP2MEAN', 'IBP3SYS', 'IBP3DIA', 'IBP3MEAN', 'IBP4SYS', 'IBP4DIA', 'IBP4MEAN', 'EtCO2', 'InCO2', 'Temp1', 'Temp2'].indexOf(vsType) !== -1) {
                const vsTypeText = vsType.replace('SYS', '').replace('DIA', '').replace('MEAN', '')
                if (units[vsTypeText] === 'kPa') {
                    return `${checkEmptyValue(mmHgToKPa(settingStatus[highAlarmString]))}/${checkEmptyValue(mmHgToKPa(settingStatus[lowAlarmString]))}`
                } else if (units[vsTypeText] === '%') {
                    return `${checkEmptyValue(mmHgToPercent(settingStatus[highAlarmString]))}/${checkEmptyValue(mmHgToPercent(settingStatus[lowAlarmString]))}`
                } else if (units[vsTypeText] === '°F') {
                    return `${checkEmptyValue(celsiusToFahrenheit(settingStatus[highAlarmString]))}/${checkEmptyValue(celsiusToFahrenheit(settingStatus[lowAlarmString]))}`
                } else if (units[vsTypeText] === '°C') {
                    return `${checkEmptyValue(settingStatus[highAlarmString]?.toFixed(1))}/${checkEmptyValue(settingStatus[lowAlarmString]?.toFixed(1))}`
                } else {
                    return `${checkEmptyValue(settingStatus[highAlarmString])}/${checkEmptyValue(settingStatus[lowAlarmString])}`
                }
            } else {
                return `${checkEmptyValue(settingStatus[highAlarmString])}/${checkEmptyValue(settingStatus[lowAlarmString])}`
            }
        } else {
            return `-/-`
        }
    }

    const isSelectedPatient = () => {
        if (isFromSearch) return false;
        if (!selectBedInfo || !bedInfo) return false
        if (selectBedInfo.deviceId == bedInfo.deviceId && selectBedInfo.devicePatientId == bedInfo.devicePatientId) return true
    }

    const isAloneWithNibpTop = () => {
        return patientCnt <= 1 && bedInfo.numericCodeList.slice(0, 3).indexOf('NIBP') !== -1
    }

    const handleUpdateDataCount = (idx, val) => {
        const newDataCountArr = [...dataCountArr]
        newDataCountArr[idx] = val
        setDataCountArr(newDataCountArr)
    }

    const renderAlarmIcon = () => {        
        if (bedInfo.suspended || (bedData?.silenceData && (bedData?.silenceData.alarmPause === '1' || bedData?.silenceData.audioPause === '1'))) { // 2) 알람 Off
            if(bedData?.silenceData?.alarmPausePeriod === 'Indefinite'){
                return <IconAlarmOff />;
            }else{
                return <IconAlarmSilence />;
            }
            
        }
        else if (isWardSilenced || (!isSilenced && bedData?.silenceData && bedData?.silenceData.silenceMode === '1')) { // 1) 병동 Silence
            return <IconAlarmSilence />;
        }
        else if (isWardSuspended) {
            return <IconAlarmOff />
        } else if (isSilenced) {
            return (
                <div className="relative w-[28px] h-[28px] flex items-center justify-center cursor-pointer"
                onClick={() => handleUnsilence()}>
                    <IconAlarmSilence />
                    <span
                    className="absolute text-[14px] text-[#DBFF00] font-medium"
                    style={{top: '50%', left: '50%', transform: 'translate(-50%, -50%)', textShadow: ` -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000`}}>
                        {remainingSeconds}
                    </span>
                </div>
            );
        } else {
            // const IconOnCmp = isSelectedPatient() ? IconAlarmOnBlack : IconAlarmOn;
            return <IconAlarmOn onClick={handleSilence} />;
        }
    };

    const getNIBPDiff = () => {
        if (!settingStatus.lastBPMonth || !settingStatus.lastBPDay) return '---'
        let nibpTime = moment()
                .set('month', settingStatus.lastBPMonth - 1)
                .set('date', settingStatus.lastBPDay)
                .set('hour', settingStatus.lastBPHour)
                .set('minute', settingStatus.lastBPMinute)
        while(nibpTime.isAfter(moment())) {
            nibpTime = nibpTime.subtract(1, 'year')
        }
        const diffTime = moment().diff(nibpTime)
        const duration = moment.duration(diffTime)
        const totalMinutes = Math.floor(duration.asMinutes())
        const hrs = Math.floor(totalMinutes / 60)
        const mins = totalMinutes % 60

        return isDisconnected ? '---' : `${hrs.toString().length > 1 ? hrs : '0' + hrs}:${mins.toString().length > 1 ? mins : '0' + mins}`
    }

    // ✅ Global 연결 상태 확인 함수
    const isGlobalConnected = (type, deviceId) => {
        //console.log('type : ', type, 'deviceId: ', deviceId);
        setGlobalConnectedDevice(prev => {
            const prevArr = Array.isArray(prev) ? prev : [];
            if (type === 'Connected') {
                if (prevArr.includes(deviceId)) return prevArr;
                return [...prevArr, deviceId];
            } else if (type === 'DisConnected') {                
                return prevArr.filter(id => id !== deviceId);
            }
            return prevArr;
        });
    };

    // Device 별 Menu 렌더링
        const renderMenus = () => {
            const modelInfo = deviceModelMenus.find(item => item.model === bedInfo.deviceModel);            
            const menus = [];               
    
            if (modelInfo.trendSupported) {
                menus.push(
                    <div key={`trend-${bedInfo.serial}`} onClick={() => { setSelectBedInfo(bedInfo); handleTrend('open'); setIsFromSearch(false) }} className="flex items-center justify-center gap-1 text-white cursor-pointer" style={{ width: 28, height: 28 }}>
                        <IconTrend className=""/>
                    </div>
                );
            }
            if (modelInfo.alarmReviewSupported) {
                menus.push(
                    <div key={`alarm-${bedInfo.serial}`} onClick={() => { setSelectBedInfo(bedInfo); handleAlarmReview('open'); setIsFromSearch(false) }} className="flex items-center justify-center gap-1 text-white cursor-pointer" style={{ width: 28, height: 28 }}>
                        <IconAlarmReview className=""/>
                    </div>
                );
            }
            if (modelInfo.nibpSupported) {
                menus.push(
                    <div key={`measurements-${bedInfo.serial}`} onClick={() => { setSelectBedInfo(bedInfo); handleMeasurements('open'); setIsFromSearch(false) }} className="flex items-center justify-center text-white cursor-pointer">
                        <IconMeasurements className="" />
                    </div>
                );
            }    
            if (modelInfo.bedSettingSupported) {
                menus.push(
                    <div key={`setting-${bedInfo.serial}`} onClick={() => { setSelectBedInfo(bedInfo); handleBedSetting('open'); setIsFromSearch(false) }} className="flex items-center justify-center text-white cursor-pointer">
                        <IconSetting className="" />
                    </div>
                );
            }
    
            return menus;
        }

    const clearSerialAllDataQueues = useCallback((serial, waveCodeList = []) => {
        const defaultTypes = ['RESP', 'PLETH']
        const activeTypes = (waveCodeList || []).filter(t => t && t !== 'NONE')
        const targetTypes = [...new Set([...defaultTypes, ...activeTypes])]

        targetTypes.forEach(type => {
            clearDataQueue(serial, type)
        })
    }, [clearDataQueue])

    useEffect(() => {
        if (wardStatusChangeFlag) {
            if (wardSuspend == '0') {
                unSilenceAll()
            }
        }
    }, [wardStatusChangeFlag])


    useEffect(() => {
        if (isFirstStandbyRenderRef.current) {
            isFirstStandbyRenderRef.current = false
            prevStandbyModeRef.current = isStandbyMode
            prevDemoModeRef.current = demoMode
            return
        }

        const standbyChanged = prevStandbyModeRef.current !== isStandbyMode
        const demoChanged = prevDemoModeRef.current !== demoMode

        if (standbyChanged || demoChanged) {
            updateBedData(prev => {
                if (!prev || !prev[bedInfo.serial]) return prev
                return {
                    ...prev,
                    [bedInfo.serial]: {
                        ...prev[bedInfo.serial],
                        waveData: {}
                    }
                }
            });
            clearSerialAllDataQueues(bedInfo.serial, bedInfo.waveCodeList)
        }

        prevStandbyModeRef.current = isStandbyMode
        prevDemoModeRef.current = demoMode
    }, [isStandbyMode, demoMode])

    useEffect(() => {
        setHeight(initialHeight)
    }, [initialHeight])

    useEffect(() => {
        // setIsStandByMode(bedInfo.standbyMode) //StandBy 모드 여부
        const speedSettings = bedInfo.waveSettings?.map(ws => { return { parameter: ws.measureParameter, speed: ws.swapSpeed } })
        if (speedSettings) {
            const newMeasurementSettings = { ...measurementSettings }
            speedSettings.forEach(ss => {
                if (ss.parameter && speedStringByType[ss.parameter]) {
                    newMeasurementSettings[speedStringByType[ss.parameter]] = ss.speed
                }
            })
            setMeasurementSettings(newMeasurementSettings)
        }
        const filteredWaveCodeList = bedInfo.waveCodeList ? bedInfo.waveCodeList.filter(item => item !== 'NONE') : null
        switch(patientCnt) {
            case 4:
            case 3:
                setArr(filteredWaveCodeList?.slice(0, 1) || [])
                setDataCountArr([0])
                break;
            case 2:
                setArr(filteredWaveCodeList?.slice(0, 2) || [])
                setDataCountArr([0, 0])
                break;
            case 1:
                setArr(filteredWaveCodeList?.slice(0, 3) || [])
                setDataCountArr([0, 0, 0])
                break;
        }
        
    }, [bedInfo])

    useEffect(() => {   
        // if(bedInfo.deviceModel == 'V20'){
        //     setIsDisconnected(false)
        // }        
        if (bedData) {
            const newBedData = {
                numericData: bedData.numericData ? { ...bedData.numericData } : {},
                waveData: bedData.waveData ? { ...bedData.waveData } : {},
                settingData: bedData.settingData ? { ...bedData.settingData } : {}
                // outOfRange: []
            }
            const ibpTypeValueStringArr = [];
            ['NIBP', 'IBP1', 'IBP2', 'IBP3', 'IBP4'].forEach((typeKey) => {
                ibpTypeValueStringArr.push(...[`${typeKey.toLowerCase()}DiaValue`, `${typeKey.toLowerCase()}SysValue`, `${typeKey.toLowerCase()}MapValue`])
            })

            Object.keys(bedData.numericData || {}).forEach(key => {
                // IBP일때는 0이거나 값이 없을때만 값 세팅
                if (ibpTypeValueStringArr.indexOf(key) !== -1 && (!newBedData.numericData[key])) {
                    newBedData.numericData[key] = bedData.numericData[key]
                } else {
                    newBedData.numericData[key] = bedData.numericData[key]
                }
            })

            if (bedData.outOfRangeData?.length > 0) {
                const newOutOfRange = []
                const outOfRangeSeries = ['HR', 'SpO2', 'RESP', 'IBP1', 'IBP2', 'IBP3', 'IBP4', 'Co2', 'GAS', 'Temp1', 'Temp2']
                const outOfRangeTypes = bedData.outOfRangeData.map((item) => item.alarmType)
                outOfRangeTypes.forEach((item) => {
                    if (item === 'ECG') { newOutOfRange.push('HR', 'PR')}
                    else if (item === 'SPO2') { newOutOfRange.push('SpO2', 'PR')}
                    else if (item === 'CO2') { newOutOfRange.push('EtCO2', 'InCO2', 'IPI') }
                    else if (item === 'TEMP1') { newOutOfRange.push('Temp1') }
                    else if (item === 'TEMP2') { newOutOfRange.push('Temp2') }
                    else { newOutOfRange.push(item) }
                })
                setOutOfRange(newOutOfRange)
            } else {
                setOutOfRange([])
            }

            const bpSeries = ['NIBP', 'IBP1', 'IBP2', 'IBP3', 'IBP4']
            bpSeries.forEach((item) => {
                if (units[item] === 'kPa') {
                    newBedData.numericData[`${item.toLowerCase()}SysValue`] = mmHgToKPa(newBedData.numericData[`${item.toLowerCase()}SysValue`])
                    newBedData.numericData[`${item.toLowerCase()}DiaValue`] = mmHgToKPa(newBedData.numericData[`${item.toLowerCase()}DiaValue`])
                    newBedData.numericData[`${item.toLowerCase()}MapValue`] = mmHgToKPa(newBedData.numericData[`${item.toLowerCase()}MapValue`])
                }
            })

            const co2Series = ['EtCO2', 'InCO2']
            co2Series.forEach((item) => {
                if (units[item] === 'kPa') {
                    newBedData.numericData[valueStringByType[item]] = mmHgToKPa(newBedData.numericData[valueStringByType[item]])
                }
                else if (units[item] === '%') {
                    newBedData.numericData[valueStringByType[item]] = mmHgToPercent(newBedData.numericData[valueStringByType[item]])
                }
            })

            const tempSeries = ['Temp1', 'Temp2']
            tempSeries.forEach(item => {
                if (units[item] === '°F') {
                    newBedData.numericData[valueStringByType[item]] = celsiusToFahrenheit(newBedData.numericData[valueStringByType[item]])
                } else {
                    if (isNaN(parseFloat(newBedData.numericData[valueStringByType[item]])?.toFixed(1))) {
                        newBedData.numericData[valueStringByType[item]] = null
                    } else {
                        newBedData.numericData[valueStringByType[item]] = parseFloat(newBedData.numericData[valueStringByType[item]])?.toFixed(1)
                    }
                }
            })

            if (units['GAS'] === 'mmHg') {
                newBedData.numericData[valueStringByType['GasO2Ex']] = percentTommHg(newBedData.numericData[valueStringByType['GasO2Ex']])
                newBedData.numericData[valueStringByType['GasO2In']] = percentTommHg(newBedData.numericData[valueStringByType['GasO2In']])
                newBedData.numericData[valueStringByType['GasCo2Ex']] = percentTommHg(newBedData.numericData[valueStringByType['GasCo2Ex']])
                newBedData.numericData[valueStringByType['GasCo2In']] = percentTommHg(newBedData.numericData[valueStringByType['GasCo2In']])
                newBedData.numericData[valueStringByType['GasSevEx']] = percentTommHg(newBedData.numericData[valueStringByType['GasSevEx']])
                newBedData.numericData[valueStringByType['GasSevIn']] = percentTommHg(newBedData.numericData[valueStringByType['GasSevIn']])
                newBedData.numericData[valueStringByType['GasDesEx']] = percentTommHg(newBedData.numericData[valueStringByType['GasDesEx']])
                newBedData.numericData[valueStringByType['GasDesIn']] = percentTommHg(newBedData.numericData[valueStringByType['GasDesIn']])
                newBedData.numericData[valueStringByType['GasN2OEx']] = percentTommHg(newBedData.numericData[valueStringByType['GasN2OEx']])
                newBedData.numericData[valueStringByType['GasN2OIn']] = percentTommHg(newBedData.numericData[valueStringByType['GasN2OIn']])
            } else if (units['GAS'] === 'kPa') {
                newBedData.numericData[valueStringByType['GasO2Ex']] = percentToKpa(newBedData.numericData[valueStringByType['GasO2Ex']])
                newBedData.numericData[valueStringByType['GasO2In']] = percentToKpa(newBedData.numericData[valueStringByType['GasO2In']])
                newBedData.numericData[valueStringByType['GasCo2Ex']] = percentToKpa(newBedData.numericData[valueStringByType['GasCo2Ex']])
                newBedData.numericData[valueStringByType['GasCo2In']] = percentToKpa(newBedData.numericData[valueStringByType['GasCo2In']])
                newBedData.numericData[valueStringByType['GasSevEx']] = percentToKpa(newBedData.numericData[valueStringByType['GasSevEx']])
                newBedData.numericData[valueStringByType['GasSevIn']] = percentToKpa(newBedData.numericData[valueStringByType['GasSevIn']])
                newBedData.numericData[valueStringByType['GasDesEx']] = percentToKpa(newBedData.numericData[valueStringByType['GasDesEx']])
                newBedData.numericData[valueStringByType['GasDesIn']] = percentToKpa(newBedData.numericData[valueStringByType['GasDesIn']])
                newBedData.numericData[valueStringByType['GasN2OEx']] = percentToKpa(newBedData.numericData[valueStringByType['GasN2OEx']])
                newBedData.numericData[valueStringByType['GasN2OIn']] = percentToKpa(newBedData.numericData[valueStringByType['GasN2OIn']])

                // newBedData.numericData[valueStringByType['GasO2Ex']] = 360.5
                // newBedData.numericData[valueStringByType['GasO2In']] = 360.5
                // newBedData.numericData[valueStringByType['GasCo2Ex']] = 360.5
                // newBedData.numericData[valueStringByType['GasCo2In']] = 360.5
                // newBedData.numericData[valueStringByType['GasSevEx']] = 360.5
                // newBedData.numericData[valueStringByType['GasSevIn']] = 360.5
                // newBedData.numericData[valueStringByType['GasDesEx']] = 360.5
                // newBedData.numericData[valueStringByType['GasDesIn']] = 360.5
                // newBedData.numericData[valueStringByType['GasN2OEx']] = 360.5
                // newBedData.numericData[valueStringByType['GasN2OIn']] = 360.5
                // newBedData.numericData.gasO2Measurement = true
                // newBedData.numericData.gasAA1Measurement = true
                // newBedData.numericData.gasAA2Measurement = true
                // newBedData.numericData.gasCO2Measurement = true
                // newBedData.numericData.gasN2OMeasurement = true
            }

            if (['M40', 'M50', 'M40/M50'].indexOf(bedInfo.deviceModel) !== -1) {
                if(newBedData.settingData.rrOnOff){
                    if (newBedData.numericData.rrSource === 'Impedance') { // ECG로 되어있으면 무조건 '-'
                        newBedData.numericData[valueStringByType['awRR']] = '-'
                    } else {
                        newBedData.numericData[valueStringByType['RR']] = '-'
                        newBedData.numericData[valueStringByType['RESP']] = '-'
                    }
    
                    if (newBedData.numericData.rrSource === 'Airway') {
                        setIsDetecting(prev => ({ ...prev, 'awRR': 'co2Measurement' }))
                        if (!newBedData.numericData.co2Measurement) {
                            newBedData.numericData[valueStringByType['awRR']] = '-'
                        }
                    } 
                    if (newBedData.numericData.rrSource === 'Airway2 (from Gas)') {
                        setIsDetecting(prev => ({ ...prev, 'awRR': 'gasCO2Measurement' }))
                        if (!newBedData.numericData.gasCO2Measurement) {
                            newBedData.numericData[valueStringByType['awRR']] = '-'
                        }
                    }
                }
            } else {
                if(newBedData.settingData.rrOnOff){
                    if (newBedData.numericData.rrSource === 'Airway') {
                        setIsDetecting(prev => ({ ...prev, 'awRR': 'co2Measurement' }))
                        if (!newBedData.numericData.co2Measurement) {
                            newBedData.numericData[valueStringByType['awRR']] = '-'
                        }
                    } 
                    if (newBedData.numericData.rrSource === 'Airway2 (from Gas)') {
                        setIsDetecting(prev => ({ ...prev, 'awRR': 'gasCO2Measurement' }))
                        if (!newBedData.numericData.gasCO2Measurement) {
                            newBedData.numericData[valueStringByType['awRR']] = '-'
                        }
                    }

                    if (newBedData.numericData.rrSource === 'Impedance') { // ECG로 되어있으면 무조건 '-'
                        newBedData.numericData[valueStringByType['awRR']] = '-'
                    } else {
                        newBedData.numericData[valueStringByType['RR']] = '-'
                        newBedData.numericData[valueStringByType['RESP']] = '-'
                    }
                }
            }

            setIsDetecting(prev => ({ ...prev, 'PR': `${newBedData.numericData.hrprSource?.toLowerCase()}Measurement` }))
            if (newBedData.numericData.hrprSource === 'ECG') {
                newBedData.numericData[valueStringByType['PR']] = newBedData.numericData.hrValue 
            } else if (['SpO2', 'IBP1', 'IBP2', 'IBP3', 'IBP4', 'NIBP'].includes(newBedData.numericData.hrprSource)) {
                if (['IBP1', 'IBP2', 'IBP3', 'IBP4'].includes(newBedData.numericData.hrprSource)) {
                    if (['PAP', 'ICP', 'CVP', 'RAP', 'LAP', 'UVP', 'IC1', 'IC2'].includes(newBedData.settingData[`${newBedData.numericData.hrprSource.toLowerCase()}Label`])) {
                        newBedData.numericData[valueStringByType['PR']] = '-'
                    } else {
                        newBedData.numericData[valueStringByType['PR']] = newBedData.numericData[`${newBedData.numericData.hrprSource.toLowerCase()}PulseRate`] 
                    }
                } else {
                    newBedData.numericData[valueStringByType['PR']] = newBedData.numericData[`${newBedData.numericData.hrprSource.toLowerCase()}PulseRate`] 
                    if (newBedData.numericData.hrprSource === 'NIBP') {
                        newBedData.numericData.nibpMeasurement = !(checkIBPZero(newBedData.numericData.nibpSysValue, '', '', true) === '-' && checkIBPZero(newBedData.numericData.nibpDiaValue, '', '', true) === '-' && checkIBPZero(newBedData.numericData.nibpMapValue, '', '', true) === '-')
                    }
                }
            }

            setMeasurementSettings(prev => {
                return {
                    ...prev,
                    intervalSeconds: newBedData.settingData?.nibpIntervalSeconds || prev.intervalSeconds,
                }
            })
            setIsStandByMode(bedData.silenceData?.standByMode == '1')

            // V20인 경우 Recoil에 데이터를 넣어 둠. (V20은 실시간 데이터가 아닌 전송 할때만 한번 보내기 떄문)
            if(bedInfo.deviceModel == 'V20'){
                //console.log('newBedData.numericData', newBedData.numericData);
                setV20DatasState(prev => ({
                    ...prev,
                    [bedInfo.serial]: {
                        recordTimestamp: new Date().getTime(),
                        numericData: newBedData.numericData,
                    }
                }));
            }

            if (bedInfo.serial == '111122223333') {
                // console.log(bedData.silenceData)
                // console.log(bedData.numericData)
                // console.log(newBedData.settingData)
                // console.log(bedData.alarmData)
                // console.log(bedData.silenceData)
            }
            setSettingStatus(newBedData.settingData)   
            setVsData(newBedData.numericData)

            const isConnected = bedData.connectionStatus
            if (!isConnected) {
                setIsDisconnected(true)
                isGlobalConnected('Disconnected', bedInfo.deviceId);

                setVsData({})
                setSettingStatus({})
                setAlarmLimitData({})  
                clearAlarmState(); // disconnect 시 알람 상태 초기화
                
                // Rodney - disconnect후 reconnect 됐을 때 끊기기 전 알람이 남아있어서 아예 데이터 날려버리고 다시 받기 위해 삭제함.
                // bedDataRecoil에서 해당 serial 데이터 제거
                updateBedData(prev => {
                    if (!prev || !prev[bedInfo.serial]) return prev;
                    const newData = { ...prev };
                    delete newData[bedInfo.serial];
                    return newData;
                });
            } else {
                setIsDisconnected(false)
                isGlobalConnected('Connected', bedInfo.deviceId);

            }
        }
    
    }, [bedData])

    useEffect(() => {
        return () => {
            if (isDisconnectedTimerRef.current) {
                clearTimeout(isDisconnectedTimerRef.current)
            }
        }
    }, [])

    const getAdaptiveFontSize = (value, maxWidth = 100) => {
        const valueStr = String(value || '');
        const length = valueStr.length;
        
        // 기본 폰트 크기
        let fontSize = 40;
        
        // 길이에 따라 폰트 크기 조정
        if (length > 4) {
            fontSize = Math.max(20, 40 - (length - 4) * 3);
        }
        return fontSize;
    };

    const numericStyles = useMemo(
        () => getStyles32({ patientCnt, isVSM: false }),
        [patientCnt]
    )
    const vsmStyles = useMemo(
        () => getStyles32({ patientCnt, isVSM: true }),
        [patientCnt]
    )

    const getAlarmStringCb = useCallback((vsType) => getAlarmString(vsType), [settingStatus, units])
    const getNIBPDiffCb = useCallback(() => getNIBPDiff(), [settingStatus, isDisconnected])

    const isAloneWithNibpTopCb = useCallback(() => isAloneWithNibpTop(), [patientCnt, bedInfo.numericCodeList])

    const commonProps = useMemo(() => ({
        vsData, settingStatus, outOfRange, units, isDetecting, parameterColors,
        getAlarmStringFn: getAlarmStringCb,
        getNIBPDiff: getNIBPDiffCb,
        getAdaptiveFontSize,
        isAloneWithNibpTop: isAloneWithNibpTopCb,
        patientCnt,
    }), [vsData, settingStatus, outOfRange, units, isDetecting, parameterColors, getAlarmStringCb, getNIBPDiffCb, getAdaptiveFontSize, isAloneWithNibpTopCb, patientCnt])

    return (
        <div onClick={() => { if(selectBedInfo && bedInfo.serial && !isDisconnected) { setSelectBedInfo(bedInfo); setIsFromSearch(false)} }} className={`relative flex flex-col flex-grow`} style={{ backgroundColor: (!isStandbyMode && !isDisconnected && alarms[bedInfo.serial]?.length > 0 && hasUnacknowledgedAlarms) ? '#02008B' : 'black', width: '100%', maxHeight: `${100 - ((patientCnt - 1) * 12.5)}%`, minHeight: '12.5%', height: `${height}px`, outline: '1px solid #fff'}} onMouseEnter={(e) => { setIsMouseOver(true) }} onMouseLeave={() => { setIsMouseOver(false) }}>
            {
                bedInfo.serial &&
                <div className="flex flex-col flex-grow" style={{ height: '100%' }} >
                    <div className="flex items-center" style={{ minHeight: 32, maxHeight: 32 }}>
                        <div className={`flex h-full items-center justify-center text-white bg-gradient-to-b ${bedInfo.serial ? isSelectedPatient() ? 'from-[#DEDEDE]' : 'from-[#5E5E5E]' : 'from-[#FF002E]'} ${bedInfo.serial ? isSelectedPatient() ? 'to-[#9F9F9F]' : 'to-[#383838]' : 'to-[#99001C]'}`} style={{ fontWeight: 500, fontSize: 24, lineHeight: '24px', maxWidth: 178, minWidth: 178, background: isDisconnected ? 'linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%), linear-gradient(180deg, #FF002E 0%, #99001C 100%)' : '' }}>
                            {checkEmptyValue(bedInfo.bedNumber.length <= 1 ? `0${bedInfo.bedNumber}` : bedInfo.bedNumber, `${t('dashboard.bedName')}-`)}
                        </div>
                        <div className="flex items-center" style={{ width: 'calc(100% - 178px)' }}>
                            {
                                bedInfo.serial &&
                                !isStandbyMode &&
                                <>
                                    {
                                        !isDisconnected &&
                                        <>
                                            <div className="cursor-pointer" style={{ zIndex: 2, color: isSelectedPatient() ? 'black' : '', width: 28, height: 28 }}>
                                                { renderAlarmIcon() }
                                            </div>
                                        </>
                                    }
                                    {
                                        isDisconnected &&
                                        <div className="ml-1"  style={{ color: isSelectedPatient() ? 'black' : '', width: 28, height: 28,}}>
                                            {
                                                isSelectedPatient() ?
                                                isDisconnected ? <IconNoConnection /> : <IconNoConnectionBlack /> :
                                                <IconNoConnection />
                                            }
                                        </div>
                                    }
                                </>
                            }
                            <div className="relative flex-1 text-white truncate" style={{ zIndex: 2, marginLeft: isStandbyMode ? 5: 0, maxWidth: (!isDisconnected && !isStandbyMode && hasUnacknowledgedAlarms && isMouseOver) ? 'calc(100% - 28px - 90px)' : 'calc(100% - 28px)', fontSize: 16, fontWeight: '17.6px', fontWeight: 200 }} title={isDisconnected ? '-' : bedInfo.nameDisplay === '1' ? checkEmptyValue(bedInfo.patientName) : bedInfo.nameDisplay === '2' ? checkEmptyValue(bedInfo.devicePatientId) : bedInfo.nameDisplay === '3' ? `${checkEmptyValue(bedInfo.patientName)},${checkEmptyValue(bedInfo.devicePatientId)}`: '-'}>
                                {!bedInfo.devicePatientId ? t('dashboard.notAdmitted') : (bedInfo.nameDisplay === '1' ? checkEmptyValue(bedInfo.patientName) : bedInfo.nameDisplay === '2' ? checkEmptyValue(bedInfo.devicePatientId) : bedInfo.nameDisplay === '3' ? `${checkEmptyValue(bedInfo.patientName)} , ${checkEmptyValue(bedInfo.devicePatientId)}` : '-')}
                                
                            </div>
                            {
                                !isDisconnected && !isStandbyMode && hasUnacknowledgedAlarms && isMouseOver &&
                                <div className="flex items-center justify-center gap-[10px] mr-[2px] cursor-pointer" onClick={() => { handleAcknowledge() }} style={{ zIndex: 999, boxShadow: '0px 2px 6px 0px #00000099', borderRadius: 6, background: 'linear-gradient(180deg, #FFED66 0%, #E9C300 100%)', borderImageSource: 'linear-gradient(180deg, #FFFFFF 0%, #FFF6B5 11.54%, #FFF290 100%)', minWidth: 88, maxWidth: 88, minHeight: 32, maxHeight: 32 }}>
                                    <IconAcknowledge />
                                    <span className="text-black" style={{ fontSize: 18 }}>{unacknowledgedAlarmsCount}</span>
                                </div>
                            }
                        </div>
                    </div>
                    {
                        //헤더 32px + 알림 20px + border 3px
                        isStandbyMode ?
                        <div onClick={() => { handleStandByConfirm(bedInfo.deviceId) }} className="flex flex-col items-center justify-center text-[#FFA800] cursor-pointer" style={{ height: 'calc(100% - 55px)' }}>
                            <span className="" style={{ fontWeight: 600, fontSize: 48, lineHeight: '48px' }}>{t('dashboard.standBy')}</span>
                            <span className="mt-2" style={{ fontWeight: 300, fontSize: 16, lineHeight: '16px' }}>{t('dashboard.disableStandByMessage')}</span>
                        </div> :
                        <>
                            <div className="relative" style={{ height: !bedInfo.vsmMode ? (patientCnt > 1 ? 'calc(100% - 99px)' : 'calc(100% - 223px)') : 'calc(100% - 55px)', borderBottomWidth: 1, borderColor: '#383838'}}>
                                {
                                    !bedInfo.vsmMode &&
                                    arr.map((node, idx) => {
                                        let isDetectingValue = typeof vsData[isDetecting[node]] === 'undefined' ? true : vsData[isDetecting[node]]
                                        if (node === 'RESP') { // RESP 표시는 ecgMeasurement true 이면서 rrOnOff가 true 일 때로 변경
                                            isDetectingValue = bedData?.numericData?.ecgMeasurement && bedData?.settingData?.rrOnOff
                                        }
                                        return (
                                            <ChartWrapper 
                                                key={`chart-item-${viewType}-${idx}`}
                                                isFirst={idx === 0}
                                                isDisconnected={isDisconnected}
                                                isShowECGPacer={true}
                                                chartCount={arr.length}
                                                isDetecting={isDetectingValue}
                                                data={bedData ? bedData.waveData || {} : {}}
                                                settingStatus={settingStatus}
                                                bedInfo={bedInfo}
                                                type={node}
                                                viewType={32}
                                                handleBufferCount={(bufferCnt) => { handleUpdateDataCount(idx, bufferCnt) }}
                                            />
                                        )
                                    })
                                }
                                {
                                    bedInfo.vsmMode &&
                                    <div className="relative flex" style={{ flexDirection: 'column', height: '100%', borderRightWidth: 1, borderColor: 'black', minWidth: 367 }}>
                                        <div className="flex" style={{ height: patientCnt <= 2 ? '50%' : '100%', borderBottomWidth: patientCnt <= 2 ? 0 : 1, borderTopWidth: 1, borderColor: '#383838' }}>
                                            <PatientNumeric 
                                                isLeft={true} isVSM={true} type={bedInfo.numericCodeList[0]}
                                                alarmString={getAlarmString(bedInfo.numericCodeList[0])}
                                                styles={vsmStyles} {...commonProps} />
                                            <PatientNumeric 
                                                isLeft={true} isVSM={true} type={bedInfo.numericCodeList[1]}
                                                alarmString={getAlarmString(bedInfo.numericCodeList[1])}
                                                styles={vsmStyles} {...commonProps} />
                                            <PatientNumeric 
                                                isLeft={true} isVSM={true} type={bedInfo.numericCodeList[2]}
                                                alarmString={getAlarmString(bedInfo.numericCodeList[2])}
                                                styles={vsmStyles} {...commonProps} />
                                        </div>
                                        {
                                            patientCnt <= 2 &&
                                            <div className="flex" style={{ height: '50%', borderBottomWidth: 1, borderTopWidth: 1, borderColor: '#383838' }}>
                                                <PatientNumeric isLeft={true} isVSM={true} type={bedInfo.numericCodeList[3]} alarmString={getAlarmString(bedInfo.numericCodeList[3])} styles={vsmStyles} {...commonProps} />
                                                <PatientNumeric isLeft={false} isVSM={true} type={bedInfo.numericCodeList[4]} alarmString={getAlarmString(bedInfo.numericCodeList[4])} styles={vsmStyles} {...commonProps} />
                                            </div>
                                        }
                                    </div>
                                }
                                {
                                    !isDisconnected &&
                                    bedInfo.deviceId &&
                                    bedInfo.serial &&
                                    isMouseOver &&
                                    <div className="absolute flex bg-gradient-to-b from-[#5E5E5E] to-[#1F1F1F]" style={{ top: 4, left: 4, borderRadius: 6, zIndex: 999 }}>
                                        {/* <div onClick={() => {  }} className="flex items-center justify-center mr-1 text-white cursor-pointer" style={{ width: 28, height: 28 }}>
                                            <IconPrint className=""/>
                                        </div>
                                        <div onClick={() => {  }} className="flex items-center justify-center mr-1 text-white cursor-pointer" style={{ width: 28, height: 28 }}>
                                            <IconWide className=""/>
                                        </div> */}
                                        {/* <div onClick={() => { setSelectBedInfo(bedInfo); handleTrend('open'); setIsFromSearch(false) }} className="flex items-center justify-center gap-1 text-white cursor-pointer" style={{ width: 28, height: 28 }}>
                                            <IconTrend className=""/>
                                        </div>
                                        <div onClick={() => { setSelectBedInfo(bedInfo); handleAlarmReview('open'); setIsFromSearch(false) }} className="flex items-center justify-center gap-1 text-white cursor-pointer" style={{ width: 28, height: 28 }}>
                                            <IconAlarmReview className=""/>
                                        </div>
                                        <div onClick={() => { setSelectBedInfo(bedInfo); handleMeasurements('open'); setIsFromSearch(false) }} className="flex items-center justify-center text-white cursor-pointer">
                                            <IconMeasurements className="" />
                                        </div>
                                        <div onClick={() => { setSelectBedInfo(bedInfo); handleBedSetting('open'); setIsFromSearch(false) }} className="flex items-center justify-center text-white cursor-pointer">
                                            <IconSetting className="" />
                                        </div> */}
                                        {renderMenus()}
                                    </div>
                                }
                            </div>
                            {
                                bedInfo.serial &&
                                !bedInfo.vsmMode &&
                                <div className="flex" style={{ flexDirection: 'column', height: '100%', minWidth: 366, height: patientCnt > 1 ? 44 : 168 }}>
                                    <div className="flex" style={{ height: patientCnt > 1 ? '100%' : `${100 / 3}%`, borderBottomWidth: 1, borderColor: '#383838' }}>
                                        <PatientNumeric isLeft={true} type={bedInfo.numericCodeList[0]} alarmString={getAlarmString(bedInfo.numericCodeList[0])} styles={numericStyles} {...commonProps} />
                                        <PatientNumeric isLeft={true} type={bedInfo.numericCodeList[1]} alarmString={getAlarmString(bedInfo.numericCodeList[1])} styles={numericStyles} {...commonProps} />
                                        <PatientNumeric isLeft={false} type={bedInfo.numericCodeList[2]} alarmString={getAlarmString(bedInfo.numericCodeList[2])} styles={numericStyles} {...commonProps} />
                                    </div>
                                    {
                                        patientCnt <= 1 &&
                                        <>
                                            <div className="flex" style={{ height: `${100 / 3}%`, borderBottomWidth: 1, borderColor: '#383838' }}>
                                                <PatientNumeric isLeft={true} type={bedInfo.numericCodeList[3]} alarmString={getAlarmString(bedInfo.numericCodeList[3])} styles={numericStyles} {...commonProps} />
                                                <PatientNumeric isLeft={true} type={bedInfo.numericCodeList[4]} alarmString={getAlarmString(bedInfo.numericCodeList[4])} styles={numericStyles} {...commonProps} />
                                                <PatientNumeric isLeft={false} type={bedInfo.numericCodeList[5]} alarmString={getAlarmString(bedInfo.numericCodeList[5])} styles={numericStyles} {...commonProps} />
                                            </div>
                                            <div className="flex" style={{ height: `${100 / 3}%`, borderBottomWidth: 1, borderColor: '#383838'}}>
                                                <PatientNumeric isLeft={true} type={bedInfo.numericCodeList[6]} alarmString={getAlarmString(bedInfo.numericCodeList[6])} styles={numericStyles} {...commonProps} />
                                                <PatientNumeric isLeft={true} type={bedInfo.numericCodeList[7]} alarmString={getAlarmString(bedInfo.numericCodeList[7])} styles={numericStyles} {...commonProps} />
                                                <PatientNumeric isLeft={false} type={bedInfo.numericCodeList[8]} alarmString={getAlarmString(bedInfo.numericCodeList[8])} styles={numericStyles} {...commonProps} />
                                            </div>
                                        </>
                                    }
                                </div>
                            }
                        </>
                    }
                    { !isDisconnected && !isStandbyMode && alarms[bedInfo.serial]?.length > 0 && <div className='flex-1' style={{ margin: '0px 3px' }}>
                        <AlarmDropdown 
                            options={alarms[bedInfo.serial] || []}
                            isHalf={true}
                            priority={highestPriority}
                            placeholder="알람 선택"
                            isAcknowledged={isAcknowledged}
                            acknowledgeRemainingSeconds={acknowledgeRemainingSeconds}
                            getAlarmAcknowledgeStatus={getAlarmAcknowledgeStatus}
                        />
                    </div>}
                </div>
            }
            
            {
                isSelectedPatient() &&
                <div className="absolute selected-patient" style={{ width: '100%', height: '100%', background: 'transparent' }} />
            }
            {
                !bedInfo.serial &&
                <div className="flex items-center justify-center text-[#9F9F9F] cursor-pointer" style={{ height: '100%', width: '100%' }}>
                    <span className="" style={{ fontWeight: 300, fontSize: 16, lineHeight: '17.6px' }}>{t('dashboard.emptyBedMessage')}</span>
                </div>
            }
        </div>
    )
}

export default Patient